import { Navigate, NavigateProps, useLocation } from 'react-router-dom';
import { usePwcNavigate } from '@core/hooks/routing-hooks';

export type PwcNavigateProps = Omit<NavigateProps, 'to'> & {
  route: string;
  params?: Record<string, string>;
  preserveSearch?: boolean;
};

const PwcNavigate = ({ route, params, preserveSearch, ...rest }: PwcNavigateProps) => {
  const { generatePath } = usePwcNavigate();
  const location = useLocation();

  const path = generatePath(route, params);
  const to = preserveSearch && location.search ? `${path}${location.search}` : path;

  return <Navigate {...rest} to={to} />;
};

export default PwcNavigate;
